import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { forkJoin, switchMap } from 'rxjs';
import { DelegheService } from '../../service/deleghe.service';
import { FiltroService } from '../../service/filtro.service';
import { DelegaTimesheet, UtenteDelegabile } from '../../interfaces/delega.interface';

export const storicoDelegheResolver: ResolveFn<{
  deleghe: DelegaTimesheet[];
  delegheCount: number;
  deleganti: UtenteDelegabile[];
  delegabili: UtenteDelegabile[];
}> = (route, state) => {
  const delegheService = inject(DelegheService);
  const filtroService = inject(FiltroService);
  return filtroService.ultimoFiltroDeleghe.pipe(
    switchMap((filtro: any) => {
      return forkJoin({
        deleghe: delegheService.getStoricoDeleghe(filtro),
        delegheCount: delegheService.getStoricoDelegheCount(filtro),
        deleganti: delegheService.getDeleganti(),
        delegabili: delegheService.getDelegabili(),
      });
    })
  );
};
